import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input", //filter
          type: "string",
          value: "",
          intemName: "item",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
          filter: "[^0-9]",
        },
        size: "15%"
      },
      {
        label: {
          value: "Description",
          size: "104px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        readOnly: true,
        size: "31%"
      },
      {
        label: {
          value: "Line",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "line"
        },
        readOnly: true,
        size: "7.5%"
      },
      {
        label: {
          value: "Part",
          size: "50%",
          maxWidth: "140px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "part"
        },
        readOnly: true,
        size: "9.5%"
      },
      {
        label: {
          value: "Warehouses"
        },
        item: {
          node: "DCSelector",
          value: "",
          onChange: "lookup",

          intemName: "wse"
        },
        size: "37%"
      },
      {
        label: {
          value: "Vendor",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          onBlur: "checkVendor",
          type: "number",
          value: "",
          intemName: "vendor",
          size: 1
        },
        size: "15%"
      },
      {
        label: {
          value: "Vendor Name",
          size: "104px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName",
          hotMod: false
        },
        readOnly: true,
        size: "35%"
      },
      {
        label: {
          value: "Core Return",
          size: "50%",
          maxWidth: "150px",
          fontSize: "97%"
        },
        item: {
          node: "input",
          type: "number",
          onBlur: "checkVendor",
          value: "",
          intemName: "coreReturn",
          size: 1
        },
        size: "15%"
      },
      {
        label: {
          value: "Vendor Name",
          size: "104px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName2",
          hotMod: false
        },
        readOnly: true,
        size: "35%"
      },
      {
        label: {
          value: "Recall",
          size: "50%",
          maxWidth: "135px"
        },
        item: {
          node: "input",
          type: "number",
          onBlur: "checkVendor",
          value: "",
          intemName: "recall",
          size: 1
        },
        size: "15%"
      },
      {
        label: {
          value: "Vendor Name",
          size: "104px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName3",
          hotMod: false
        },
        readOnly: true,
        size: "35%"
      },
      {
        label: {
          value: "Warranty",
          size: "50%",
          maxWidth: "150px"
        },
        item: {
          node: "input",
          onBlur: "checkVendor",
          type: "number",
          value: "",
          intemName: "warranty",
          size: 1
        },
        size: "15%"
      },
      {
        label: {
          value: "Vendor Name",
          size: "104px",
          fontSize: "92%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName4",
          hotMod: false
        },
        readOnly: true,
        size: "35%"
      },
      {
        label: {
          value: "Next PO Cost",
          size: "99px",
          fontSize: "85%"
        },
        span: {
          value: "BASE"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "nextPOCost"
        },
        readOnly: true,
        size: "15%"
      },
      {
        label: {
          value: "Core",
          size: "50%"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "core",
          decimals: 2
        },
        size: "7.75%",
        readOnly: true
      },
      {
        label: {
          value: "NIPO Maintenance Date",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "NPOMaintenanceDate"
        },
        readOnly: true,
        size: "27.25%"
      },
      {
        label: {
          value: "Setup Date",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "setupDate"
        },
        readOnly: true,
        size: "15%"
      },
      {
        label: {
          value: "Change Date",
          size: "104px",
          fontSize: "95%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "changeDate"
        },
        readOnly: true,
        size: "35%"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      // Create a new array with deep copy to force GenericHeader to update
      const newLayout = this.headerLayout.map((layout, key) => {
        // Always create deep copies of item and label
        const newItem = {
          ...layout,
          item: { ...layout.item },
          label: { ...layout.label }
        };

        if (layout.item.intemName === props[key].name) {
          newItem.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          newItem.item.span = props[key].span;

          // Only set injectedValue for multi-record mode (when it's explicitly defined)
          if (props[key].injectedValue !== undefined) {
            newItem.item.injectedValue = props[key].injectedValue;
          }
          // Only update label.value if it's a string, not a JSX element
          if (typeof props[key].label === 'string') {
            newItem.label.value = props[key].label;
          }
        }
        return newItem;
      });

      return newLayout;
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    const formattedLayout = this.formatData(this.props.headerData);

    // Use formatted layout if available, otherwise use state or default
    const layout = formattedLayout || this.state.layout || this.headerLayout;

    return (
      <GenericHeader
        jsonObj={layout}
        setHeaderInfo={this.getHeaderInfo}
        warehouseList={this.props.warehouseList}
        functions={{
          lookup: this.props.lookup,
          checkVendor: this.props.checkVendor,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
